import {ClassComponent, Vnode} from 'mithril';
import listItems from 'flarum/common/helpers/listItems';
import PrivatePicture from '../models/PrivatePicture';

interface PrivatePictureThumbnailAttrs {
    picture?: PrivatePicture
}

export default class PrivatePictureThumbnail implements ClassComponent<PrivatePictureThumbnailAttrs> {
    view(vnode: Vnode<PrivatePictureThumbnailAttrs>) {
        const {picture} = vnode.attrs;

        const badges = picture?.badges().toArray();

        return m('.AlbumThumbnail.PrivatePictureThumbnail', [
            badges && badges.length ? m('ul.AlbumThumbnail-badges badges', listItems(badges)) : null,
            m('.ImagePlaceholder'),
        ]);
    }
}
